module.exports = __webpack_public_path__ + "static/equipment-banner-e1137b5128c94dcc3b23e8c0fe3ed807.png";